module.exports = __webpack_public_path__ + "6c4a0dbc/img/arrow-left-icon.785c715c.svg";